/**
 * Navigation View, responsible for displaying navigations
 */

define(function (require) {
    "use strict";

    var template = require("automation-templates/navigation.tmpl");
    var NavigationView = {};

    LE.module('LEAutomation', function (LEAutomation, LE, Backbone, Marionette, $, _) {
        NavigationView = Marionette.ItemView.extend({
            template: template,
            className: 'automation-nav-view',
            ui: {
                navigation: ".automation-nav",
                landingpage: ".nav-item-automation-landingpage",
                convBuilder: ".nav-item-automation-conversationbuilder",
                botplatform: ".nav-item-automation-botplatform",
            },

            events: {
                "click .nav-item-automation-landingpage": "_showLandingPage",
                "click .nav-item-automation-conversationbuilder": "_showConvBuilder",
                "click .nav-item-automation-botplatform": "_showBotPlatform",
            },

            modelEvents: {
                "change:selectedNav": "_manageSelectedNav",
                "change:notificationCenterEventsCounter": "_manageNotificationCenterEventsProxy",
                "change:newKPsCounter": '_manageNewKPsCounter'
            },

            initialize: function (options) {
                this.$el = options.el;
                this.contextModel = LEAutomation.contextModel;
            },

            onRender: function () {
                $(this.$el).append(this.el);
            },

            _showLandingPage: function () {
                LEAutomation.router.navigate('landing-page');
            },

            _showConvBuilder: function () {
                LEAutomation.router.navigate('conversation');
            },

            _showBotPlatform: function () {
                LEAutomation.router.navigate('bot-platform');
            },

            activateConvBuilderNav: function () {
                this.ui.landingpage.toggleClass('active', false);
                this.ui.botplatform.toggleClass('active', false);
                this.ui.convBuilder.toggleClass('active', true);
                this.ui.navigation.toggleClass('collapsed', true);
            },

            activateLandingNav: function () {
                this.ui.landingpage.toggleClass('active', true);
                this.ui.botplatform.toggleClass('active', false);
                this.ui.convBuilder.toggleClass('active', false);
                this.ui.navigation.toggleClass('collapsed', false);
            },

            activateBotPlatform: function () {
                this.ui.landingpage.toggleClass('active', false);
                this.ui.botplatform.toggleClass('active', true);
                this.ui.convBuilder.toggleClass('active', false);
                this.ui.navigation.toggleClass('collapsed', true);
            }
        });
    });

    return NavigationView;
});
